import React, { useState } from "react";

interface propsType {
  label: string;
  value: string;
  onChange: (v: string) => void;
  icon?: React.ReactNode;
  type?: string;
  placeholder?: string;
}

const ContactField = ({
  label,
  value,
  onChange,
  icon,
  type = "text",
  placeholder,
}: propsType) => (
  <div>
    <label className="block mb-2 text-sm font-medium text-slate-600 dark:text-slate-400">
      {label}
    </label>
    <div className="relative">
      {icon && (
        <div className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 dark:text-slate-500">
          {icon}
        </div>
      )}
      <input
        type={type}
        value={value || ""}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        className={`w-full border border-slate-200 dark:border-slate-600 rounded-lg py-2.5 text-sm text-slate-600 dark:text-slate-300 bg-white dark:bg-slate-700 focus:border-custom-500 dark:focus:border-custom-400 focus:outline-none transition-colors duration-200 ${
          icon ? "pl-10 pr-4" : "px-4"
        }`}
      />
    </div>
  </div>
);

export default ContactField;